<rap-roles-ui
  [roles]="roles$ | async"
  (createRoleEmitter)="createRole()"
  (editRoleEmitter)="editRole($event)"
  (deleteRoleEmitter)="deleteRole($event)"
></rap-roles-ui>
